/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { updateLikeProductRequestSchema } from "./updateLikeProductRequestSchema.ts";

export const productsLikeCreateStatus200Schema = z.any();

export const productsLikeCreateResponseSchema = productsLikeCreateStatus200Schema;

export const productsLikeCreateDataSchemaJson = updateLikeProductRequestSchema;

export const productsLikeCreateDataSchemaXml = updateLikeProductRequestSchema;

export const productsLikeCreateDataSchema = z.union([productsLikeCreateDataSchemaJson, productsLikeCreateDataSchemaXml]);
